import { handleResponseErr } from '../../utils/handleResponseErr'
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'

const DEFAULT_STATE = {
  users: null,
  user: null,
  actions:{
    get_users: {
      loading: false,
      errMsg: null,
    },
    create_user: {
      loading: false,
      errMsg: null,
      success: false,
    },
    get_user: {
      loading: false,
      errMsg: null,
    },
    update_user: {
      loading: false,
      errMsg: null,
      success: false
    }
  }
}

export default function companies (state = DEFAULT_STATE, action) {
  switch (action.type){
    /***********************
    * Get Users List
    ************************/
      // on pending
      case "GET_USERS_PENDING":
        return {
          ...DEFAULT_STATE,
          actions:{
            ...state.actions,
            get_users:{ loading: true }
          }
        }

      // on success
      case "GET_USERS_FULFILLED":
        return {
          ...state,
          users: action.payload.data.data.users,
          actions:{
            ...state.actions,
            get_users: DEFAULT_STATE.actions.get_users
          }
        }

      // on rejected
      case "GET_USERS_REJECTED":
        return {
          ...state,
          actions:{
            ...state.actions,
            get_users:{
              loading: false,
              errMsg:  handleResponseErr(action.payload)
            }
          }
        }

    /***********************
    * Get user
    ************************/
      case "GET_USER_PENDING":
        return {
          ...state,
          actions:{
            ...state.actions,
            get_user:{ loading: true }
          }
        }

      case "GET_USER_FULFILLED":
        return {
          ...state,
          user: action.payload.data.data.user,
          actions:{
            ...state.actions,
            get_user: DEFAULT_STATE.actions.get_user
          }
        }

      case "GET_USER_REJECTED":
        return {
          ...state,
          actions:{
            ...state.actions,
            get_user:{
              loading: false,
              errMsg:  handleResponseErr(action.payload)
            }
          }
        }
    /***********************
    * Create new user
    ************************/
      // on pending
      case "CREATE_USER_PENDING":
        return {
          ...state,
          actions:{
            ...state.actions,
            create_user:{ loading: true }
          }
        }

      case "CREATE_USER_FULFILLED":
        console.log('create user',state)
        const users = state.users
        users.unshift(action.payload.data.data.user)
        iziToast.success({
          title: 'Success',
          message: action.payload.data.message,
          zindex: 50000,
          position: 'topCenter',
          timeout: 3000,
          animateInside: false,
        });
        return {
          ...DEFAULT_STATE,
          users,
          actions:{
            ...state.actions,
            create_user: {
              ...DEFAULT_STATE.actions.create_user,
              success: true,
            }
          }
        }

      // on rejected
      case "CREATE_USER_REJECTED":
        return {
          ...state,
          actions:{
            ...state.actions,
            create_user:{
              loading: false,
              errMsg:  handleResponseErr(action.payload)
            }
          }
        }

      case "RESET_CREATE_USER_FORM":
        return {
          ...state,
          actions:{
            ...state.actions,
            create_user:{
              ...DEFAULT_STATE.actions.create_user
            }
          }
        }

    /***********************
    * Update User
    ************************/
      case "UPDATE_USER_PENDING":
        return {
          ...state,
          actions:{
            ...state.actions,
            update_user:{ loading: true }
          }
        }

      case "UPDATE_USER_REJECTED":
        return {
          ...state,
          actions:{
            ...state.actions,
            update_user:{
              loading: false,
              errMsg:  handleResponseErr(action.payload)
            }
          }
        }

      case "UPDATE_USER_FULFILLED":
        iziToast.success({
          title: 'Success',
          message: action.payload.data.message,
          zindex: 50000,
          position: 'topCenter',
          timeout: 3000,
          animateInside: false,
        });
        return {
          ...state,
          actions:{
            ...state.actions,
            update_user: {
              ...DEFAULT_STATE.actions.update_user,
              success: true,
            }
          }
        }

      case "RESET_UPDATE_USER_FORM":
        return {
          ...state,
          actions:{
            ...state.actions,
            update_user:{
              ...DEFAULT_STATE.actions.update_user
            }
          }
        }

      default: return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/users.js